import {memo, Suspense, useCallback, useState} from 'react';
import {Modal} from "../Modal";
import {LoaderModal} from "../../../ui/loaderModal/LoaderModal";
import {AuthContainerModalAsync} from "./authModal/AuthContainerModal.async";
import {authAction} from "../../../store/reducers/auth/authSlice";
import {useAppDispatch} from "../../../store/hooks/redux";
import {ForgotPasswordContainerModalAsync} from "../forgotPasswordModal/ForgotPasswordContainerModal.async";

interface LoginModalProps {
    isOpen: boolean
    onClose: () => void
}

type ModalView = 'auth' | 'forgotPassword'

export const LoginModal = memo(({onClose, isOpen}: LoginModalProps) => {
    const {clearErrors, clearForgotPasswordState} = authAction;
    const dispatch = useAppDispatch()
    const [view, setView] = useState<ModalView>('auth')

    const handleClose = useCallback(() => {
        onClose();
        dispatch(clearErrors());
        dispatch(clearForgotPasswordState());
        setView('auth');
    }, [onClose, dispatch, clearErrors, clearForgotPasswordState])

    const handleForgotPassword = useCallback(() => {
        dispatch(clearErrors());
        setView('forgotPassword');
    }, [dispatch, clearErrors])

    const handleBackToLogin = useCallback(() => {
        dispatch(clearForgotPasswordState());
        setView('auth');
    }, [dispatch, clearForgotPasswordState])

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            lazy
            isCenter
        >
            <Suspense fallback={<LoaderModal/>}>
                {view === 'auth' && (
                    <AuthContainerModalAsync
                        setIsActiveModal={handleClose}
                        onForgotPassword={handleForgotPassword}
                    />
                )}
                {view === 'forgotPassword' && (
                    <ForgotPasswordContainerModalAsync
                        setIsActiveModal={handleClose}
                        onBackToLogin={handleBackToLogin}
                    />
                )}
            </Suspense>

        </Modal>
    );
});
